<template>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
        <v-container grid-list-xl>
            <v-layout wrap>
                <v-flex xs12>
                    <v-switch v-model="item.enable" :label="$t('Habilitado')" class="my-0 py-0" />
                </v-flex>
                <v-flex xs12>
                    <v-text-field :label="$t('Nome')" v-model="item.name" :rules="[rules.required, rules.min(2)]" />
                </v-flex>

                <v-flex xs12>
                    <SimpleListAdd :list="item.brands" itemTitle="Marca" />
                </v-flex>

                <v-flex xs12>
                    <UserSelect :value="item.users" filter="partners" @change="item.users = $event" multiple />
                </v-flex>

                <v-flex xs12>
                    <v-alert outlined color="info" prominent border="top" icon="school">
                        Acima estão <strong>listados apenas os usuários com permissão de "Parceiro"</strong>. Caso o usuário que você deseja adicionar não está aparecendo na
                        lista, vá na tela de cadastro de usuário e adicione a Regra "Parceiro" antes.</v-alert>
                </v-flex>

                <v-flex xs12>
                    <v-btn :loading="lock" :disabled="!valid" color="success" @click="validate">Salvar</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";
import UserSelect from "@/components/shared/UserSelect";
import SimpleListAdd from "@/components/core/SimpleListAdd";

export default {
    directives: { mask },

    components: { UserSelect, SimpleListAdd },

    props: {
        itemToEdit: {
            type: Object,
        },
        lock: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            itemClean: {
                name: "",
                brands: [],
                enable: true,
            },
            item: { ...this.itemClean },
        };
    },

    watch: {
        itemToEdit: {
            immediate: true,
            handler(newVal) {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }

                this.$nextTick(() => {
                    if (newVal == null) {
                        this.item = { ...this.itemClean };
                    } else {
                        if (!newVal.brands) {
                            newVal.brands = [];
                        }
                        this.item = { ...newVal };
                    }
                });
            },
        },
    },

    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.item);
            }
        },
    },

    mounted() {
        if (this.$refs.form) {
            this.$refs.form.reset();
        }
    },
};
</script>